/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { PanelBody,SelectControl,RangeControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;



const EntranceAnimationsPanel = (myprops) => {

	const props = myprops.props;
	const {attributes,setAttributes} = props;
	const {aploeffect,aploeffectease,aploeffectduration,aploeffectdelay} = attributes;

	

	return (

		<PanelBody title={__('Aplo Entrance Styles', 'aploblocks')} initialOpen={false} className="aploentrancestyles">
		
					<SelectControl
						label={__('Effect', 'aploblocks')}
						
						value={aploeffect}
						options={[
							{label: __('<none>', 'aploblocks'),value: ''},
							{label: __('Fade In', 'aploblocks'),value: 'fadein'},
							{label: __('Fade Up', 'aploblocks'),value: 'fadeup'},
							{label: __('Fade Down', 'aploblocks'),value: 'fadedown'},
							{label: __('Scale In', 'aploblocks'),value: 'scalein'},
							{label: __('Slide In Left', 'aploblocks'),value: 'slideinleft'},
							{label: __('Slide In Right', 'aploblocks'),value: 'slideinright'},
							{label: __('Bounce', 'aploblocks'),value: 'bounce'},
							{label: __('Rotate In', 'aploblocks'),value: 'rotatein'},
							{label: __('Flip In', 'aploblocks'),value: 'flipin'},
							{label: __('Roll In Left', 'aploblocks'),value: 'rollinleft'},
							{label: __('Roll In Right', 'aploblocks'),value: 'rollinright'},
							{label: __('Blur In', 'aploblocks'),value: 'blurin'},
							{label: __('Text Expand In', 'aploblocks'),value: 'txtexpandin'},
							{label: __('Text Contract In', 'aploblocks'),value: 'txtcontractin'},
							{label: __('Text Blur Expand In', 'aploblocks'),value: 'txtblurexpandin'},
							{label: __('Text Blur Contract In', 'aploblocks'),value: 'txtblurcontractin'},


						]}
						onChange={(value) => {setAttributes({ aploeffect: value })}}
					/>

					<SelectControl
						label={__('Easing Function', 'aploblocks')}			
						value={aploeffectease}
						options={[
							{label: __('<default>', 'aploblocks'),value: ''},
							{label: __('ease (Slow-Fast-Slow)', 'aploblocks'),value: 'ease'},
							{label: __('ease-in (Slow-Fast)', 'aploblocks'),value: 'ease-in'},
							{label: __('ease-out (Fast-Slow)', 'aploblocks'),value: 'ease-out'},
							{label: __('ease-in-out (Slow-Fast-Slow)', 'aploblocks'),value: 'ease-in-out'},
						]}
						onChange={(value) => {setAttributes({ aploeffectease: value })}}
					/>
						
					<RangeControl
						label={__('Duration','aploblocks')}
						value={ aploeffectduration }
						onChange={(value) => {
							setAttributes({aploeffectduration: value});
						}}
						min={ 0 }
						max={ 5000 }
						step={50}
						allowReset={true}
					/>
					<RangeControl
						label={__('Delay','aploblocks')}
						value={ aploeffectdelay }
						onChange={(value) => {
							setAttributes({aploeffectdelay: value});
						}}
						min={ 0 }
						max={ 5000 }
						step={50}
						allowReset={true}
					/>
				</PanelBody>



	)



}



export default EntranceAnimationsPanel